import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import ConfirmModal from '../ConfirmModal';
import { modal } from '../../../../Base/Modal';
import routes from '../../../../../routes';
import types from '../../../../../redux/types';
import { userName, transformData } from '../../../../../services/helpers';

const UsersListItem = ({ user }) => {
  const dispatch = useDispatch();

  // delete
  const handleSubmitDelete = () => {
    dispatch({ type: types.DELETE_USER_START, payload: user?.id });
    modal.close();
  };

  const handleDeleteModal = () => {
    modal.open(<ConfirmModal onSubmit={handleSubmitDelete} />);
  };

  // Block
  const handleSubmitBlock = () => {
    dispatch({
      type: types.BLOCK_USER_START,
      payload: {
        id: user?.id,
        data: {
          blocked: +user?.blocked ? '0' : '1',
        },
      },
    });
    modal.close();
  };
  const handleBlockModal = () => {
    modal.open(
      <ConfirmModal onSubmit={handleSubmitBlock} blocked={user?.blocked} />,
    );
  };

  return (
    <tr data-label-tr={`Block #${user?.id}`}>
      <td data-label=" ID">
        <span>{user?.id}</span>
      </td>

      <td data-label="Full Name">
        <Link to={`${routes.Users.Profile.path}${user?.id}`} className="table-link">
          <span>{userName(user?.data?.first_name, user?.data?.last_name)}</span>
        </Link>
      </td>

      <td data-label="Email">
        <span>{user?.email || '-'}</span>
      </td>

      <td data-label="Mobile Phone">
        <span>{user?.phone || '-'}</span>
      </td>

      <td data-label="Last Login Country">
        <span>{user?.data?.last_login_country || '-'}</span>
      </td>

      <td data-label="Last Login IP">
        <span>{user?.data?.last_login_ip || '-'}</span>
      </td>

      <td data-label="Status">
        <span style={{ color: user?.is_active ? '#02d395' : '#E52E2B' }}>
          {user?.is_active === 1 ? 'online' : 'offline'}
        </span>
      </td>

      <td data-label="Last login">
        <div className="d-flex align-items-center">
          <span>{transformData(user?.last_login, 'DD/MM/YYYY') || '-'}</span>
          <div className="separator" />
          <span>{transformData(user?.last_login, 'HH:mm:ss') || '-'}</span>
        </div>
      </td>

      <td data-label="Created">
        <div className="d-flex align-items-center">
          <span>{transformData(user?.created_at, 'DD/MM/YYYY') || '-'}</span>
          <div className="separator" />
          <span>{transformData(user?.created_at, 'HH:mm:ss') || '-'}</span>
        </div>
      </td>

      <td data-label="Approved documents (Ondato)">
        <span>{user?.ondato_status || '0'}</span>
      </td>

      <td data-label="Approved documents (Shuftipro)">
        <span>{user?.count_verified_documents || '0'}</span>
      </td>

      <td data-label="KYC">
        <span>{user?.status?.name || '-'}</span>
      </td>

      <td data-label="Actions">
        <div className="dash-actions">
          <button
            type="button"
            onClick={handleBlockModal}
            className="dash-actions__item stroke-hover"
          >
            {+user?.blocked ? (
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.5 6.5V3.5C4.5 1.84315 5.84315 0.5 7.5 0.5C9.15685 0.5 10.5 1.84315 10.5 3.5V6.5M2.5 6.5H12.5C13.0523 6.5 13.5 6.94772 13.5 7.5V13.5C13.5 14.0523 13.0523 14.5 12.5 14.5H2.5C1.94772 14.5 1.5 14.0523 1.5 13.5V7.5C1.5 6.94772 1.94772 6.5 2.5 6.5Z"
                  stroke="#424242"
                />
              </svg>
            ) : (
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.5 6.5V3.5C3.5 1.84315 4.84315 0.5 6.5 0.5C8.15685 0.5 9.5 1.84315 9.5 3.5V4M1.5 6.5H11.5C12.0523 6.5 12.5 6.94772 12.5 7.5V13.5C12.5 14.0523 12.0523 14.5 11.5 14.5H1.5C0.947715 14.5 0.5 14.0523 0.5 13.5V7.5C0.5 6.94772 0.947715 6.5 1.5 6.5Z"
                  stroke="black"
                />
              </svg>
            )}
          </button>

          <button
            type="button"
            onClick={handleDeleteModal}
            className="dash-actions__item stroke-hover"
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0.5 0.5L12.5 12.5M0.5 12.5L12.5 0.5" stroke="#424242" />
            </svg>
          </button>
        </div>
      </td>
    </tr>
  );
};

export default UsersListItem;
